<template>
    <div>

        <sau-template :retrieved="gotData">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Addons</template>
            <!-- Data -->
            <template slot="data">
                <table class="table table-responsive-sm sau-table-align" cellspacing="0" width="100%" v-if="addons.length">
                    <thead>
                        <tr>
                            <th scope="col" class="nosort">&nbsp;</th>
                            <th scope="col">Addon</th>
                            <th scope="col">Status</th>
                            <th scope="col">Next Invoice Date</th>
                            <th scope="col">Next Due Date</th>
                            <th scope="col" class="text-right">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(addon, index) in addons" :key="index">
                            <th scope="row"><i class="fal fa-puzzle-piece" aria-hidden="true" style="font-size:40px; color:#0769ba;"></i></th>
                            <td v-if="addon.name && addon.name.length" v-html="addon.name"></td>
                            <td v-else v-html="addon.addonname"></td>
                            <td v-html="addon.status"></td>
                            <td>
                                <template v-if="addon.nextinvoicedate != null">{{ addon.nextinvoicedate | moment('DD/MM/YYYY') }}</template>
                            </td>
                            <td>
                                <template v-if="addon.nextduedate != null">{{ addon.nextduedate | moment('DD/MM/YYYY') }}</template>
                            </td>
                            <td class="text-right">
                                <template v-if="addon.recurring != null">{{ addon.recurring | currency }}</template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="sau-bx text-center">
                    <div class="row p-2 mb-3">
                        <div class="col">
                            <img src="/img/illustrations/puzzle.svg" width="140" class="mx-auto"/>
                            <h4>You don't have any addons</h4>
                        </div>
                    </div>
                </div>
            </template>
        </sau-template>

    </div>
</template>
<script>
import { mapState } from 'vuex';
    export default {
        props: ['id'],
        data() {
            return {
                addons: []
            };
        },
        created() {
            this.startApp();
        },
        computed: {
            ...mapState(['sales']),
            productDisplay(){
                return _.sampleSize(Object(this.products),2)
            }
        },
        methods: {
            startApp() {
                this.getAddons().then(response => {
                    this.addons = response.data;
                })
            }
        }
    }
</script>
